import { render, staticRenderFns } from "./new.pages.page.vue?vue&type=template&id=ad9d7f3e&"
import script from "./new.pages.page.vue?vue&type=script&lang=js&"
export * from "./new.pages.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports